import React from "react";
import { Typography } from "@optimizely/axiom";

import { NavLinks } from "../../components/NavLinks/NavLinks";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import "./Layout.css";
import "../../../scrollable-table.scss";
import { UserGroupProvider } from "../../components/UserGroupForm/UserGroupFormContext/UserGroupContext";
import { FormProvider } from "../../components/UserForm/UserFormContext/UserFormContext";
import { ITab } from "../../../lib/navigation-types";

const Layout = ({
    children,
    headerText,
    pageDescription,
    tabs
}: {
    children: React.ReactNode;
    headerText: string;
    pageDescription?: string;
    tabs: ITab[];
}) => {
    return (
        <div className="layout-container flex flex--column">
            <Breadcrumbs />
            {headerText && (
                <Typography className="layout-header" tag="h1" type="header1">
                    {headerText}
                </Typography>
            )}
            {pageDescription && (
                <div className="content-container">
                    <Typography type="caption" tag="p" className="push-double--left push-double--bottom">
                        {pageDescription}
                    </Typography>
                </div>
            )}
            <UserGroupProvider>
                <FormProvider>
                    {tabs.length > 0 ? <NavLinks links={tabs} /> : null}
                    {children}
                </FormProvider>
            </UserGroupProvider>
        </div>
    );
};

export default Layout;
